import React, { useState } from "react";
import axios from "axios";
import { useNavigate, Link } from "react-router-dom";
import { API_BASE_URL } from "../config/api";
import Swal from "sweetalert2";

function ParentLogin() {
  const navigate = useNavigate();
  const [form, setForm] = useState({
    email: "",
    password: "",
    schoolCode: "",
  });
  const [error, setError] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "email") {
      setForm({ ...form, email: value.trim().toLowerCase() });
      return;
    }

    if (name === "schoolCode") {
      setForm({ ...form, schoolCode: value.trim().toUpperCase() });
      return;
    }

    setForm({ ...form, [name]: value });
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");

    try {
      const res = await axios.post(`${API_BASE_URL}/parent/login`, form);
      console.log("Parent Login Response:", res.data);

      if (res.data.success) {
        // ✅ Save Auth Data
        localStorage.setItem("token", res.data.token);
        localStorage.setItem("role", (res.data.role || "parent").toLowerCase());
        localStorage.setItem("parentId", res.data._id);
        localStorage.setItem("parentName", res.data.name);

        // ✅ Save Permissions
        localStorage.setItem("permissions", JSON.stringify(res.data.permissions || []));

        // ✅ Parent School Info
        localStorage.setItem("schoolName", res.data.schoolName || "");
        localStorage.setItem("schoolCode", res.data.schoolCode || "");
        localStorage.setItem("schoolId", res.data.schoolId || "");
       

   localStorage.setItem("parentId", res.data.parentId);
   localStorage.setItem("parentName", res.data.parentName);
   localStorage.setItem("childName", res.data.childName || "");
   localStorage.setItem("schoolId", res.data.schoolId);

        

        // Trigger Header to re-render immediately
        window.dispatchEvent(new Event("storage"));

        // ✅ Redirect to uniform page
        navigate("/parent/uniform", { replace: true });
      }
    } catch (err) {
      const message = err.response?.data?.message || "Login Failed";
      setError(message);
      Swal.fire({
        icon: "error",
        title: "Login Failed",
        text: message,
      });
    }
  };

  return (
    <section
      style={{
        textAlign: "center",
        padding: "50px",
        display: "flex",
        justifyContent: "center",
        alignContent: "center",
        backgroundImage:
          "url(https://png.pngtree.com/background/20210709/original/pngtree-cartoon-education-training-cram-school-picture-image_917042.jpg)",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div className="container mt-5 col-md-5">
        <form
          onSubmit={handleLogin}
          className="form-control p-4 shadow"
          style={{
            background: "rgba(255,255,255,0.15)",
            backdropFilter: "blur(10px)",
            WebkitBackdropFilter: "blur(10px)",
            border: "1px solid rgba(255,255,255,0.3)",
          }}
        >
          <h3 className="p-4 text-light">Parent Login</h3>

          <input
            name="email"
            value={form.email}
            onChange={handleChange}
            placeholder="Email"
            className="form-control w-75 text-center mx-auto"
            required
          />
          <br />
          <input
            name="password"
            type="password"
            value={form.password}
            onChange={handleChange}
            placeholder="Password"
            className="form-control w-75 text-center mx-auto"
            required
          />
          <br />
          <input
            name="schoolCode"
            value={form.schoolCode}
            onChange={handleChange}
            placeholder="Enter School Code"
            className="form-control w-75 text-center mx-auto"
            required
          />
          <br />

          {error && <p style={{ color: "red" }}>{error}</p>}

          <button className="btn border-light w-75 text-light">Login</button>

          <div className="d-flex justify-content-around mt-3">
            <p
              onClick={() => navigate("/parent/forgot")}
              style={{ cursor: "pointer", color: "white" }}
            >
              Forgot Password?
            </p>
            <Link to="/parent/register" className="nav-link text-light">
              Register
            </Link>
          </div>
        </form>
      </div>
    </section>
  );
}

export default ParentLogin;
